import React from 'react'
import { Form } from 'semantic-ui-react'

/**
 * @param {object} props
 * @param {boolean} props.value is reverse order
 * @param {function} props.onChange
 * @param {string=} props.className
 */
export default function EmbedCodeChoiceOrderForm({ value: isReverseOrder, onChange, className }) {
  function handleChange(e, { value }) {
    if (value === 'true') {
      onChange(true)
    } else {
      onChange(false)
    }
  }

  return (
    <Form className={className}>
      <Form.Group grouped>
        <label>Display order</label>
        <Form.Checkbox
          checked={!isReverseOrder}
          onChange={handleChange}
          radio
          value="false"
          label="Positive to negative"
          name="choiceOrder"
        />
        <Form.Checkbox
          checked={isReverseOrder}
          onChange={handleChange}
          radio
          value="true"
          label="Negative to positive"
          name="choiceOrder"
        />
      </Form.Group>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmbedCodeChoiceOrderForm/index.js